<template>
  <div class="container">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item v-if="location">
        {{ location | uppercase }}
      </el-breadcrumb-item>
      <el-breadcrumb-item v-if="categorySafe">
        {{ $t('category.' + categorySafe.key) | uppercase }}
      </el-breadcrumb-item>
      <el-breadcrumb-item
        v-if="subcategorySafe"
        :to="{ name: 'Welcome' }"
      >
        {{ $t('subcategory.'+ categorySafe.key + '.' +
          subcategorySafe.key) | uppercase }}
      </el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { dataGet } from '@fps/vue-toolkit/dist/util';

export default {
  // eslint-disable-next-line vue/require-prop-types
  props: ['category', 'subcategory'],
  computed: {
    categorySafe() {
      return this.category || this.stateCategory;
    },
    subcategorySafe() {
      return this.subcategory || this.stateSubcategory;
    },
    ...mapState({
      location: state => dataGet('location.name', state.filters),
      stateCategory: state => dataGet('category', state.filters),
      stateSubcategory: state => dataGet('subcategory', state.filters),
    }),
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/BreadCrumb.vue